module.exports = __webpack_public_path__ + "static/media/CGG-BNB.0655d868.svg";